import * as Sentry from '@sentry/react';
import { createBrowserRouter } from 'react-router';
import { RouterProvider } from 'react-router/dom';

let routes;

// Different tenants have different routes in some cases so we dynamically
// import the correct routes based on the environment variable. This allows us
// to reduce the bundle size by not including routes that are not used.
switch (import.meta.env.VITE_DMHI_ENTITY) {
  case 'be':
    ({ default: routes } = await import('./_be'));
    break;
  case 'hk':
    ({ default: routes } = await import('./_hk'));
    break;
  case 'dhsc':
    ({ default: routes } = await import('./_dhsc'));
    break;
  case 'abbvie':
    ({ default: routes } = await import('./_abbvie'));
    break;
  default:
    ({ default: routes } = await import('./_global'));
}

const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouterV7(createBrowserRouter);
const router = sentryCreateBrowserRouter(routes);

function Router() {
  return (
    <RouterProvider router={router} />
  );
}

export default Router;
